var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6484 15.0515C29.6484 23.1413 23.0898 29.7 15 29.7C6.91014 29.7 0.351562 23.1413 0.351562 15.0515C0.351562 6.96165 6.91014 0.403076 15 0.403076C23.0898 0.403076 29.6484 6.96165 29.6484 15.0515Z",
    fill: "url(#paint0_linear_64_62)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7516 16.2292V22.2688H20.2504V16.6346C20.2504 15.2194 19.7455 14.253 18.4769 14.253C17.5105 14.253 16.9354 14.9045 16.6817 15.5344C16.5886 15.7588 16.5657 16.0711 16.5657 16.3874V22.2689H13.0633C13.0633 22.2689 13.1104 12.7255 13.0633 11.7376H16.5657V13.2304C16.5593 13.2419 16.5491 13.2532 16.5427 13.2647H16.5657V13.2304C17.0311 12.514 17.861 11.4901 19.7213 11.4901C22.0252 11.4901 23.7516 12.9958 23.7516 16.2292ZM9.40151 6.66162C8.20298 6.66162 7.42017 7.4483 7.42017 8.48107C7.42017 9.49211 8.18007 10.3004 9.35563 10.3004H9.37731C10.5988 10.3004 11.3587 9.49217 11.3587 8.48107C11.3357 7.44836 10.5988 6.66162 9.40151 6.66162ZM7.628 22.2689H11.1279V11.7376H7.628V22.2689Z",
    fill: "#E0E7EB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_62",
    x1: 15,
    y1: 0.403076,
    x2: 15,
    y2: 29.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A1D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#156FBC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ab4e1dfb0a32d7121e2cb8856eba5599.svg";
export { ForwardRef as ReactComponent };